export default {
  VEASY: 8,
  EASY: 12,
  MEDIUM: 24,
  HARD: 36,
  SHARD: 72,
}
